import React from 'react';

const OverviewSection = ({ stats }) => {
  const { totalBids = 0, loadingBids = false, limitAlert } = stats || {};

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {/* Total Bids Card - Spans 2 columns on md+ screens */}
      <div className="md:col-span-2 bg-gradient-to-br from-primary-blue to-blue-600 rounded-xl p-4 text-white shadow-lg">
        <div className="flex justify-between items-start mb-2">
          <div>
            {loadingBids ? (
              <div className="text-3xl font-semibold mb-2 animate-pulse">Loading...</div>
            ) : (
              <div className="text-3xl font-semibold mb-1">{totalBids}</div>
            )}
            <div className="text-blue-100 text-sm font-medium">Total Bids Placed</div>
          </div>
        </div>
        
        {/* Progress Bar */}
        <div className="mt-1">
          <div className="w-full bg-white/30 rounded-full h-2">
            <div 
              className="bg-white rounded-full h-2 transition-all duration-300" 
              style={{ width: totalBids > 0 ? '80%' : '0%' }}
            ></div>
          </div>
        </div>
      </div>

      {/* Limit Alert Card - Spans 2 columns on md+ screens */}
      <div className="md:col-span-2 bg-white rounded-xl p-4 border-[1.5px]  border-primary-blue shadow-sm">
        <div className="flex items-start gap-4 mt-2">
          <img 
            src="/Icons/danger-icon.svg" 
            alt='danger-icon'
            className="w-16 h-16 object-contain flex-shrink-0"
          />
          <div>
            <h3 className="font-semibold text-gray-900 text-lg mb-1">Limit Alert</h3>
            <p className="text-sm text-gray-600">{limitAlert?.message || 'No alerts at this time'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewSection;
